<template>
  <v-layout class="grey lighten-4 pa-3" column>
    <div v-if="tabs.length > 1">
      <v-tabs
        v-model="activeTab"
        grow>

        <v-tab v-for="(tab, index) in tabs" :key="`tab-${index}`" :to="{ name: tab.name }">
          {{ $t(tab.tabMenu) }}
        </v-tab>
      </v-tabs>

      <v-tabs-items
        v-model="activeTab"
        touchless>
        <v-tab-item
          :transition="false"
          :reverse-transition="false"
          class="grey lighten-4"
          v-for="(tab, index) in tabs"
          :key="`item-${index}`"
          :value="tab.route">
          <div v-if="tab.route === activeTab">
            <router-view />
          </div>
        </v-tab-item>
      </v-tabs-items>
    </div>

    <div v-else>
      <router-view />
    </div>
  </v-layout>
</template>

<script>
export default {
  name: 'Expense',
  data () {
    return {
      activeTab: null
    }
  },
  computed: {
    tabs () {
      const tabs = [
        { tabMenu: 'menu.expense.invoice', name: 'InvoiceBox', route: `/expense/invoice-box`, roles: ['manager'] },
        { tabMenu: 'menu.expense.paymentOrders', name: 'Payment', route: `/expense/payment-orders`, roles: ['manager'] },
        { tabMenu: 'menu.expense.conciliation', name: 'Conciliation', route: `/expense/conciliation`, roles: ['manager'] },
        { tabMenu: 'menu.expense.movements', name: 'OtherMovements', route: `/expense/other-movements`, roles: ['manager'] }
      ]
      return tabs.filter(tab => tab.roles.includes(this.$is()))
    }
  }
}
</script>
